import { render, staticRenderFns } from "./AnimalNutritionPoultryPage.vue?vue&type=template&id=50d58f7a&scoped=true&"
import script from "./AnimalNutritionPoultryPage.vue?vue&type=script&lang=js&"
export * from "./AnimalNutritionPoultryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d58f7a",
  null
  
)

export default component.exports